// extracted by mini-css-extract-plugin
export default {"container":"Phone_container__Pn71A","open":"Phone_open__loqfF","input":"Phone_input__FPxev","button":"Phone_button__Fl4rv","error":"Phone_error__HH9WB"};